import { Button, Modal, theme } from 'antd';
import { COLOR_THEME } from './utils/constants';
const { defaultAlgorithm, darkAlgorithm } = theme;

const generateThemeConfig = ({ newColor, isdarkMode }) => {
  if (isdarkMode === undefined) {
    if (localStorage.getItem('mainTheme') === 'dark') {
      isdarkMode = true;
    } else {
      isdarkMode = false;
    }
  }

  let primaryColor = '#1890FF'; // Default primary color
  if (newColor) {
    primaryColor = newColor;
  } else if (
    localStorage.getItem(COLOR_THEME) &&
    localStorage.getItem(COLOR_THEME) !== 'light' &&
    localStorage.getItem(COLOR_THEME) !== 'dark'
  ) {
    primaryColor = localStorage.getItem(COLOR_THEME);
    localStorage.setItem(COLOR_THEME, primaryColor);
  }

  return {
    algorithm: isdarkMode ? darkAlgorithm : defaultAlgorithm,
    token: {
      fontFamily: '"Inter", sans-serif',
      colorPrimary: primaryColor,
      colorPrimaryLight: adjustColor(primaryColor, 20),
      colorText: isdarkMode ? 'rgba(255, 255, 255, 0.87)' : '#333333', // Softer white for dark mode
      colorTextBase: isdarkMode ? 'rgba(255, 255, 255, 0.87)' : '#333333',
      colorTextMuted: isdarkMode ? '#B0B0B0' : '#656973', // Lighter gray for muted text
      colorTextLight: isdarkMode ? '#3A3F44' : '#FFFFFF',
      colorBgLayout: isdarkMode ? '#191919' : '#FFFFFF', // Notion's dark gray background
      colorBorder: isdarkMode ? '#2A2A2A' : '#E5E7EB', // Subtle borders in dark mode
      colorBgContainer: isdarkMode ? '#202124' : '#FFFFFF', // For containers
      borderRadius: 8,
      controlHeightLG: 40,
      siderBg: isdarkMode ? '#202124' : '#ffffff',
      triggerBg: '#ffffff',
      colorLinkHover: adjustColor(primaryColor, 20),
      colorLinkActive: adjustColor(primaryColor, 50),
    },
    components: {
      Button: {
        colorPrimary: primaryColor,
        // defaultHoverColor: '#ffffff',
        // defaultActiveColor: adjustColor(primaryColor, 50),
        colorText: isdarkMode ? 'rgba(255, 255, 255, 0.87)' : '#333333',
        borderRadius: 6,
      },
      Menu: {
        colorItemText: isdarkMode ? 'rgba(255, 255, 255, 0.87)' : '#333333',
        colorItemTextHover: primaryColor,
        colorItemTextSelected: isdarkMode ? '#3A3F44' : '#FFFFFF',
        colorSelectedBg: adjustColor(primaryColor, 20),
        colorItemTextSelected: primaryColor,
        colorItemTextHover: primaryColor,
      },
      Typography: {
        colorTextHeading: primaryColor,
        colorTextTitle: adjustColor(primaryColor, -10),
        textTransform: 'none',
      },
      Input: {
        colorPrimaryHover: adjustColor(primaryColor, 10),
        colorBorder: isdarkMode ? '#2A2A2A' : '#F0F0F0',
        borderRadius: 6,
        colorTextPlaceholder: isdarkMode ? 'rgba(255, 255, 255, 0.6)' : '#999999',
      },
      Card: {
        colorBorder: '#2A2A2A', // Muted borders
        colorTextCaption: '#B0B0B0',
        colorBg: '#1D1D1D', // Card background similar to Notion’s panels
      },
      Drawer: {
        colorPrimaryText: primaryColor,
        drawerHeaderPadding: '16px',
      },
      Modal: {
        titleColor: isdarkMode ? '#FFFFFF' : '#333333',
      },
      Tooltip: {
        colorBg: '#2A2A2A',
        colorText: '#FFFFFF',
      },
    },
  };
};

// Helper function to adjust color brightness
function adjustColor(color, percent) {
  const num = parseInt(color.replace('#', ''), 16),
    amt = Math.round(2.55 * percent),
    R = (num >> 16) + amt,
    G = ((num >> 8) & 0x00ff) + amt,
    B = (num & 0x0000ff) + amt;
  return (
    '#' +
    (
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)
  );
}

export default generateThemeConfig;
